<template>
  <v-navigation-drawer
    v-model="showDialog"
    disable-resize-watcher
    disable-route-watcher
    fixed
    temporary
    right
    :width="width"
  >
    <v-card
      flat
      class="result-dialog"
      v-if="userLesson !== null && userLesson.lesson != null"
    >
      <v-toolbar flat color="grey lighten-4">
        <v-btn icon @click.native="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ userLesson.lesson.name }} -
          {{ userLesson.updated_at | moment('Do MMMM YYYY') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card flat class="pa-4 action-buttons grey lighten-4">
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="active = 'pre_quiz'"
            :class="{ activeButton: active == 'pre_quiz' }"
            :dark="active == 'pre_quiz' ? true : false"
            >pre quiz</v-btn
          >
          <v-btn
            text
            @click="active = 'lesson'"
            :class="{ activeButton: active == 'lesson' }"
            :dark="active == 'lesson' ? true : false"
            >other questions</v-btn
          >
          <v-btn
            text
            @click="active = 'post_quiz'"
            :class="{ activeButton: active == 'post_quiz' }"
            :dark="active == 'post_quiz' ? true : false"
            >post quiz</v-btn
          >
        </v-card-actions>

        <v-slide-y-transition>
          <div
            class="border-top tab-wrap pa-3 pb-0"
            v-if="active == 'pre_quiz'"
          >
            <quiz-result
              v-for="(quiz, index) in preQuiz"
              :key="index"
              :quiz="quiz"
              :questionIndex="index"
              class="mb-3"
            />
            <v-card-actions>
              <v-spacer />
              <p class="headline score">
                Your score: <em>{{ getCorrect(preQuiz) }}</em> out of
                <em>{{ preQuiz.length }}</em>
              </p>
            </v-card-actions>
          </div>
          <div class="border-top tab-wrap" v-else-if="active == 'lesson'">
            <view-lesson :questions="otherQuestions" />
          </div>
          <div
            class="border-top tab-wrap pa-3 pb-0"
            v-else-if="active == 'post_quiz'"
          >
            <quiz-result
              v-for="(quiz, index) in postQuiz"
              :key="index"
              :quiz="quiz"
              :questionIndex="index"
              class="mb-3"
            />
            <v-card-actions>
              <v-spacer />
              <p class="headline score">
                Your score: <em>{{ getCorrect(postQuiz) }}</em> out of
                <em>{{ postQuiz.length }}</em>
              </p>
            </v-card-actions>
          </div>
        </v-slide-y-transition>
      </v-card>
    </v-card>
    <!-- </v-dialog> -->
  </v-navigation-drawer>
</template>

<script>
import QuizResult from './QuizResult'
import ViewLesson from './ViewLesson'
import UserLesson from '@/modules/lesson/models/UserLesson'
import Lesson from '@/modules/lesson/models/Lesson'

export default {
  name: 'ResultDialog',
  components: {
    QuizResult,
    ViewLesson
  },
  data() {
    return {
      showDialog: false,
      active: 'pre_quiz',
      userLesson: null,
      width: 0
    }
  },
  computed: {
    preQuiz() {
      if (!this.userLesson) {
        return []
      }
      return this.userLesson.user_lesson_slides
        .filter(slide => slide.lesson_slide.name === 'pre_quiz')
        .sort((a, b) => a.lesson_slide.order - b.lesson_slide.order)
    },
    postQuiz() {
      if (!this.userLesson) {
        return []
      }
      return this.userLesson.user_lesson_slides
        .filter(slide => slide.lesson_slide.name === 'post_quiz')
        .sort((a, b) => a.lesson_slide.order - b.lesson_slide.order)
    },
    otherQuestions() {
      if (!this.userLesson) {
        return []
      }
      return this.userLesson.user_lesson_slides
        .filter(
          slide =>
            slide.lesson_slide.name !== 'post_quiz' &&
            slide.lesson_slide.name !== 'pre_quiz' &&
            slide.lesson_slide.name !== 'static'
        )
        .sort((a, b) => a.lesson_slide.order - b.lesson_slide.order)
    }
  },
  async mounted() {
    this.width = window.innerWidth * 0.9
    window.addEventListener('resize', () => {
      this.width = window.innerWidth * 0.9
    })
  },
  methods: {
    close() {
      this.showDialog = false
      this.userLesson = null
    },
    async show(id) {
      this.userLesson = await UserLesson.find(id)
      this.userLesson.lesson = await Lesson.find(this.userLesson.lesson_id)
      this.showDialog = true
    },
    getCorrect(quizzes) {
      if (quizzes.length) {
        return quizzes.filter(quiz => quiz.answer.is_correct).length
      }
      return 0
    }
  }
}
</script>

<style lang="scss">
.result-dialog {
  .border-top {
    border-top: solid 20px var(--v-primary-base);
    border-bottom: solid 1px #ccc;
    border-left: solid 1px #ccc;
    border-right: solid 1px #ccc;
  }

  .action-buttons {
    .activeButton {
      background: var(--v-primary-base) !important;
      box-shadow: none !important;
      height: 45px;
      margin-bottom: -8px;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .score {
    em {
      font-style: normal;
      color: var(--v-primary-base);
    }
  }
}
</style>
